export default __webpack_public_path__ + "static/media/photos.b9fa36b4.png";